/* index.js */

"use strict";
require("document-register-element");
